import EquipmentClass from './EquipmentClass'
export class EquipmentTypeClassXref {
    ID: number;
    EquipmentTypeCode: string;
    EquipmentClassID: number;
    EquipmentClass: EquipmentClass;
}

export default EquipmentTypeClassXref;